import { render, staticRenderFns } from "./CommissionActionUnapprove.vue?vue&type=template&id=761b5cd4&"
import script from "./CommissionActionUnapprove.vue?vue&type=script&lang=ts&"
export * from "./CommissionActionUnapprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports